module.exports = __webpack_public_path__ + "media/unipod/cabin_assembly-09a65609.jpg";